import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=5b59cec9&scoped=true"
import script from "./addressBook.vue?vue&type=script&lang=ts"
export * from "./addressBook.vue?vue&type=script&lang=ts"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=5b59cec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59cec9",
  null
  
)

export default component.exports